import { Util } from '../common_utils/util';
import { RespCacheHelper } from '../common_utils/resp_cache_helper';
import { OauthClient } from './oauth_client';
import { IAjaxMetrics } from './iajax_metrics';
import { IAjaxHelperConfig } from './iajax_helper_config';
import { AjaxHelperConfig } from './ajax_helper_config';
import { AjaxFailureHelper } from './ajax_failure_helper';
// import logger from 'logger_module';
//import $ from 'jquery';
import { MetricsHelper } from '../common_utils/metrics_helper';
import { ITranslator } from '../aggr_module/translators/itranslator';



/**
 * Responsible to perform all AJAX operations. It takes the AjaxHelperConfig object as input. 
 * @export
 * @class AjaxHelper
 */
export class AjaxHelper {

    private ajaxHelperConfig = new AjaxHelperConfig();// assign default values
    private ajaxFailureHelper: AjaxFailureHelper | undefined;
    public static respCacheHelper = RespCacheHelper.getInstance();
    private promise = new Promise((resolve, reject) => {
        this.ajaxHelperConfig.setPromiseRef({ resolve, reject });
    });

    constructor(config: IAjaxHelperConfig) {
        this.isManditoryInputPresent(config);
        //@ts-ignore
        this.ajaxHelperConfig = $.extend(true, this.ajaxHelperConfig, config);
        this.getRequestHeaders(this.ajaxHelperConfig.requestConfig, this.ajaxHelperConfig.options);
    }

    isManditoryInputPresent(config: IAjaxHelperConfig) {
        if (!Util.isValidUrl(config.requestConfig.url)) {
            throw new Error('url is not present or proper');
        }
        const type = config.requestConfig.type;
        if (!type || !(type && (type === 'GET' || type === 'POST' || type === 'PUT' || type === 'DELETE'))) {
            throw new Error('type not present');
        }
    }

    getAjaxHelperConfig() {
        return this.ajaxHelperConfig;
    }

    getAjaxFailureHelperObj(): AjaxFailureHelper {
        return new AjaxFailureHelper(this);
    }

    send(): any {
        this.setFinalEndPoint();
        const requestConfig = this.ajaxHelperConfig.requestConfig;
        const options = this.ajaxHelperConfig.options;
        if (options && options.includeHeaders) {
            requestConfig.beforeSend = (jqXHR: object, settings: object) => {
                this.ajaxHelperConfig.setRequestStartTime(new Date().getTime());
            };
        }
        this.getRequestHeaders(requestConfig, options);

        try{
            //@ts-ignore
            const payload = this.ajaxHelperConfig.requestConfig;
            //@ts-ignore
            if(photoOrg.aggSdkUtils && photoOrg.aggSdkUtils.isTabbedView()){
                //@ts-ignore
                if(photoOrg.history.historyState.st == photoOrg.constants.GOOGLE_VIEW){
                    payload.url = payload.url.indexOf("?") == -1 ? payload.url+"?assetSource=GGL" : payload.url+"&assetSource=GGL";
                }else{
                    payload.url = payload.url.indexOf("?") == -1 ? payload.url+"?assetSource=host" : payload.url+"&assetSource=host";
                }
            }
        }catch(e){}
        
        
        OauthClient.checkAndGetRefreshToken(AjaxHelperConfig.getCorsProxySettings().url, this.ajaxHelperConfig.getNoodle(),
            this.getRequestHeaders.bind(this, requestConfig, options)/* updating access token in request config */)
        this.getAjaxObj(this.ajaxHelperConfig.requestConfig).always((data: any, textStatus: string, jqXHR: any) => {
            // adding the retry of ajax call incase if the ajax call failure callback doesn't get executed:
            // self.errorHandledThroughFailBlock - key for tracking whether failure callback is triggered or not
            const reqConfig = this.ajaxHelperConfig.requestConfig;
            MetricsHelper.captureMetrics(new Date().getTime()/*requestEndTime*/,
                this.ajaxHelperConfig.getRequestStartTime(), reqConfig.url, reqConfig.type, '', ''/* callback */,
                this.ajaxHelperConfig.getNoodle(), jqXHR.status || data.status);
            let benchmark = 0;
            try{
                benchmark = ((new Date().getTime() - this.ajaxHelperConfig.getRequestStartTime()) / 1000)
            }catch(e){}
            let urlServiceMetrics = Object.assign({ description: 'API call Service metrics', benchmark: benchmark,quickLogger: true, status: jqXHR.status, noodle: this.ajaxHelperConfig.getNoodle(), apiUrl: reqConfig.url, type: reqConfig.type})

            if (jqXHR && jqXHR.status && jqXHR.status.toString().indexOf('20') > -1) {
                //urlServiceMetrics.response = JSON.stringify(data);
                this.ajaxSuccessCallback(data, jqXHR);
            } else {
                urlServiceMetrics.errorThrown = jqXHR;
                urlServiceMetrics.textStatus = textStatus;
                urlServiceMetrics.status = data.status
                urlServiceMetrics.response = JSON.stringify(data.responseText);
                // For failure data => jqXHR  and jqXHR => errorThrown
                // As per documentation : jqXHR.always(function( data|jqXHR, textStatus, jqXHR|errorThrown ) { });
                this.ajaxFailureCallback(data/*jqXHR*/, textStatus, jqXHR/*errorThrown*/);
            }
            if(urlServiceMetrics.data){
                urlServiceMetrics.requestPayload = JSON.stringify(urlServiceMetrics.data);
                delete urlServiceMetrics.data
            }
            //on success or failure log the metrics
            console.log(urlServiceMetrics);
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.info(urlServiceMetrics);
        });
        

        return this.promise;
    }

    getAjaxObj(requestConfig: IAjaxHelperConfig['requestConfig']): any {
        //@ts-ignore
        return $.ajax(requestConfig);
    }

    getRequestHeaders(requestConfig: IAjaxHelperConfig['requestConfig'], options: IAjaxHelperConfig['options']): void {
        requestConfig.headers.GSID = OauthClient.getOauthConfig().GSID;
        if (!requestConfig.ignoreAToken) {
            requestConfig.headers.access_token = "OAuth " + OauthClient.getOauthConfig().accessToken;
        }
        requestConfig.headers.Authorization = "OAuth " + OauthClient.getOauthConfig().accessToken;
        //@ts-ignore
        $.extend(true, requestConfig.headers, { 'Content-Type': 'application/json' });
}

    private verifyIsUnauthorized(data: any, jxhr: any, promiseRef: any): boolean {

        if (data.error !== undefined
            && (data.error === 'Cannot find the refresh token in the session' /*Global session expired after48hours*/
                || (data.error === '401' && !OauthClient.checkOauthAvailable())/*CorsProxy returns success with thirdparty 401 response*/)) {
            let responseInfo = data;
            // try {
            //     responseInfo = JSON.stringify(responseInfo);
            // } catch (e) {
            //     logger.warn({
            //         description: 'LIBRARY:AjaxHelper:verifyIsUnauthorized',
            //         errorCode: 'LIBRARY:AjaxHelper', err_desc: e, err_stack: e.stack
            //     });
            // }
            promiseRef.reject({ isUnauthorized: true, responseInfo, redirectToLogin: true });
            return true; // exception
            // TODO need to handle this
            // photoOrg.clientLogger.warn({description: "AssetFetcher : success block but got error response",
            // status_code: "200", Noodle: self.noodle, responseText: photoOrg.Util.getFormattedMessage(responseInfo),
            // url: self.url});
            // photoOrg.Util.getLoginRedirectUrl();
        }
        return false;
    }

    private ajaxSuccessCallback(data: any, jqXHR: any): void {
        const promiseRef = this.ajaxHelperConfig.getPromiseRef();
        if (AjaxHelperConfig.getCorsProxySettings().isCorsRequested &&
            this.verifyIsUnauthorized(data, jqXHR, promiseRef)) {// check for only cors proxy code codition
            return;
        }
        promiseRef.resolve({
            data, url: this.ajaxHelperConfig.requestConfig.url,
            type: this.ajaxHelperConfig.requestConfig.type
        });
    }

    private ajaxFailureCallback(jqXHR: any, textStatus: string, errorThrown: string) {
        if (!this.ajaxFailureHelper) {
            this.ajaxFailureHelper = this.getAjaxFailureHelperObj();
        }
        this.ajaxFailureHelper.ajaxFailureCallback({ jqXHR, textStatus, errorThrown });
    }

    /**
     * enableApiHitWithMainHost=== true
     * iteration == 0  main domain
     * iteration > 0 and above service host
     * 
     * enableApiHitWithMainHost === false
     * iteration === 2  main domain
     * iteration < 2 and above service host
     * 
     * serviceHostUrl url contains actual api provide domain
     **/
    setFinalEndPoint(){
        try{               
            if(Util.isValidUrlForBaseDomainConvertion(this.ajaxHelperConfig.requestConfig.url) && ((this.ajaxHelperConfig.options.includeHeaders === undefined || this.ajaxHelperConfig.options.includeHeaders))
            &&((AjaxHelperConfig.enableApiHitWithMainHost && this.ajaxHelperConfig.getIterationCount() === 0) ||
            (!AjaxHelperConfig.enableApiHitWithMainHost && this.ajaxHelperConfig.getIterationCount() === 2))){        
                this.ajaxHelperConfig.requestConfig.serviceHostUrl = this.ajaxHelperConfig.requestConfig.url; 
                this.ajaxHelperConfig.requestConfig.url = Util.convertToBaseDomainHostNameUrl(    
                    this.ajaxHelperConfig.requestConfig.url, AjaxHelperConfig.getCorsProxySettings().domainUrl);
            }else{
                this.ajaxHelperConfig.requestConfig.url = this.ajaxHelperConfig.requestConfig.serviceHostUrl || this.ajaxHelperConfig.requestConfig.url;
            }
        }catch(e){
            this.ajaxHelperConfig.requestConfig.url = this.ajaxHelperConfig.requestConfig.serviceHostUrl || this.ajaxHelperConfig.requestConfig.url;
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:AjaxHelper:setFinalEndPoint', errorCode: 
            'LIBRARY:ON_SETTING_FINAL_URL', err_desc: e.stack});    

        }

        try{
            var requestUrl = this.ajaxHelperConfig.requestConfig.url;
            if (requestUrl.indexOf("googleapis") === -1) {
                this.ajaxHelperConfig.requestConfig.url = requestUrl.indexOf("os=") > 0 ? requestUrl : //@ts-ignore
                requestUrl.indexOf("?") > 0 ? requestUrl + "&bn=" +jQuery.browser.name + "&os=" + jQuery.browser.platform : requestUrl + "?bn=" + jQuery.browser.name + "&os=" + jQuery.browser.platform;
            }
        }catch(e){}
    }
    
    /**    
     *    
     * Going to save or Delete the response    
     * @static    
     * @param {IAjaxHelperConfig} config    
     * @param {*} response    
     * @memberof AjaxHelper    
     */

    static saveOrDeleteRespCache(config:IAjaxHelperConfig, response: any){    
        try{    
            if(RespCacheHelper.isRespCachingEnabled && !config.requestConfig.ignoreResCaching) {    
                //saving response into the responseCache    
                if (config.requestConfig.type === "GET") {    
                    this.respCacheHelper.saveToCache(config.requestConfig.cacheKey || 'owned', config.requestConfig.serviceHostUrl || config.requestConfig.url, response);    
                }    
                //deleting response cache    
                if (config.requestConfig.type !== "GET") {    
                    this.respCacheHelper.deleteRespCache({detail: {cacheKey: config.requestConfig.cacheKey || 'all'}});    
                } 
            } 
        }catch(e){    
            //@ts-ignore
            photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:AjaxHelper:triggerApi', errorCode: 'LIBRARY:ON_CACHING_RESPONSE', err_desc: e.stack});    
        }
    }
    /**
     * Method is going to do ajax call and return the translated response.
     * If caching response feature is on, we are save cache and reading from response cache.
     * To do this, we are using RespCacheHelper class.
     * @param config 
     * @param translatorCallBack 
     */
    static triggerApi(config: IAjaxHelperConfig, translatorCallBack?: any): any {
        
        if(RespCacheHelper.isRespCachingEnabled){
            if(config.requestConfig.type === "GET"){
                var cachedResp  = this.respCacheHelper.readFromCache(config.requestConfig.cacheKey || 'owned', config.requestConfig.url);
                if(cachedResp){
                    var cacheResolve:any = undefined;
                    var cachePromise = new Promise((resolve, reject) => {
                        cacheResolve = { resolve, reject };
                    });
                    try {
                        //@ts-ignore
                        photoOrg.clientLogger && photoOrg.clientLogger.info({
                                    description: 'LIBRARY:AjaxHelper:ReadingFromCache:Success',
                                    cacheKey: config.requestConfig.cacheKey || 'owned',
                                    url: config.requestConfig.url,
                                    quickLogger: true});
                    } catch (error) {
                        //@ts-ignore
                        photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:AjaxHelper:triggerApi', errorCode: 'LIBRARY:LoggingCountError', err_desc: error.stack});
                    }

                    setTimeout(function(){
                        cacheResolve.resolve(cachedResp);
                    }, 20)
                    return cachePromise;
                }
            }
        }
        let promise = this.getAjaxHelper(config)
            .send()
            .then(
                (response: any) => {
                    if (translatorCallBack) {
                        response.data = translatorCallBack(response.data);
                    }
                    AjaxHelper.saveOrDeleteRespCache(config, response);
                    return response;
                }
            ).catch((errorDetails: any) => {
                errorDetails.service="PASCAL_SERVICE";
                if (errorDetails.errorType === "API_FAILURE") {
                    return Promise.reject(errorDetails);
                } else {                    
                    //@ts-ignore
                    photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:AjaxHelper:triggerApi', errorCode: 'LIBRARY:SCRIPT_EXCEPTION', err_desc: errorDetails.stack? errorDetails.stack :JSON.stringify(errorDetails)});
                    window.dispatchEvent(new CustomEvent("ShowErrorOverlay", { detail: { noodle: "SCRIPT_EXCEPTION" } }));
                    return Promise.reject({ errorType: "SCRIPT_EXCEPTION", errorThrown: errorDetails });
                }
            })
        return promise;
    }

    static getAjaxHelper(requestConfig: IAjaxHelperConfig): AjaxHelper {
        return new AjaxHelper(requestConfig);
    }


}
//@ts-ignore
photoOrg.AjaxHelper = AjaxHelper;
